// Atlas Calendar — page entry for /calendar.

import { Calendar } from '@/v2/v3/Calendar'

// v3 rebuild: /calendar renders the v3 Calendar screen (upcoming earnings
// via the live earnings_calendar feed, shared shell). The legacy
// AppLayout-based week/month/agenda body was trimmed in the B4 cleanup —
// see git history. The calendar component dir (WeekView/MonthView/
// AgendaView/Overlays) stays live via the /v2 desktop museum.
export function V2CalendarPage() {
  return <Calendar />
}
